import { KibsiClient } from './base';
const SERVICE = 'tenant';
export class FloorPlanKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    list(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { floorPlanIds, siteId } = criteria ?? {};
        return this.get('/floor-plans', {
            ...requestConfig,
            ...{ params: { continuationToken, pageSize, sort, floorPlanIds: floorPlanIds?.join(','), siteId } },
        });
    }
    read(entityId, requestConfig) {
        return this.get(`/floor-plans/${entityId}`, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post('/floor-plans', entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/floor-plans/${entity.floorPlanId}`, entity, requestConfig);
    }
    delete(id, requestConfig) {
        return this.del(`/floor-plans/${id}`, requestConfig);
    }
    getImageUploadUrl(streamId, contentType, requestConfig) {
        return this.put(`/floor-plans/${streamId}/image`, null, { ...requestConfig, params: { contentType } });
    }
    getImageDownloadUrl(streamId, requestConfig) {
        return this.get(`/floor-plans/${streamId}/image`, requestConfig);
    }
}
//# sourceMappingURL=floor-plan.js.map